import { useRuntimeConfig } from '#app'
import * as Sentry from '@sentry/nuxt'

const runtimeConfig = useRuntimeConfig()
const dsn = runtimeConfig.public.sentryDsn

const isEnabledEnv
    = runtimeConfig.public.appEnv === 'production'
    || runtimeConfig.public.appEnv === 'staging'

if (isEnabledEnv && dsn) {
    Sentry.init({
        dsn,
        environment: runtimeConfig.public.appEnv,
        initialScope: {
            tags: { app: 'jobseeker' },
        },
    })
}
